import { GrowthDashboardTopBarActions, LocalCitationsView } from '@elva/ui';
import { useCallback } from 'react';
import { AsyncBoundary } from '@/components/feedback';
import { usePageTopBar } from '@/app/layouts/pageTopBar';
import { viewProps } from '@/data/viewProps';
import { useCitationMutations, useCitations } from '../hooks/useCitations';

export function CitationsPage() {
  usePageTopBar({
    actions: <GrowthDashboardTopBarActions />,
  });

  const { data, isPending, isError, error, refetch, isRefetching, isFetching } = useCitations();
  const {
    createListing,
    claimListing,
    helpResolve,
    pendingDirectoryKey,
  } = useCitationMutations();

  const handleCreateListing = useCallback(
    (directoryKey: string) => {
      createListing.mutate(directoryKey);
    },
    [createListing],
  );

  const handleClaimListing = useCallback(
    (directoryKey: string) => {
      claimListing.mutate(directoryKey);
    },
    [claimListing],
  );

  const handleHelpResolve = useCallback(
    (directoryKey: string) => {
      helpResolve.mutate(directoryKey);
    },
    [helpResolve],
  );

  const actionsPending =
    createListing.isPending || claimListing.isPending || helpResolve.isPending;

  return (
    <AsyncBoundary
      loading={isPending}
      error={data === undefined && isError ? error : undefined}
      onRetry={refetch}
      retrying={isRefetching}
    >
      <LocalCitationsView
        {...viewProps({
          tiers: data?.tiers,
          stats: data?.stats,
          napSource: data?.napSource,
          scanInfo: data?.scanInfo,
          loading: isFetching || actionsPending,
          onCreateListing: handleCreateListing,
          onClaimListing: handleClaimListing,
          onHelpResolve: handleHelpResolve,
          pendingDirectoryKey,
        })}
      />
    </AsyncBoundary>
  );
}
